export const content = [
    'All',
    'Web_Development',
    'Data_structure_and_Algorithms',
    'Programming_Languages',
  ];

export  const courses = [
    {
      Data_structure_and_Algorithms: [{ DSA: ['B31LgI4Y4DQ', 'BBpAmxU_NQo'] }],
    },
    {
      Web_Development: [
        { HTML: ['UB1O30fR-EE', 'HcOc7P5BMi4'] },
        { CSS: ['yfoY53QXEnI', '1Rs2ND1ryYc'] },
        { Javascript: ['hdI2bqOjy3c', 'W6NZfCO5SIk'] },
        { ReactJs: ['w7ejDZ8SWv8', 'Ke90Tje7VS0'] },
      ],
    },
    {
      Programming_Languages: [
        { Cpp: ['ZzaPdXTrSb8', 'vLnPwxZdW4Y'] },
        { Java: ['UmnCZ7-9yDY', 'aQatrXw0njs'] },
        { Python: ['vLqTf2b6GZw', '_uQrJ0TkZlc'] },
      ],
    },
  ];